export class OutagesFilterInfo {
    searchTerm: string | null;
    categoryIds: number[] | null;
    itemTypeIds: number[] | null;
    startFromDate: string;
    startToDate: string;
}
